<div class="modal-backdrop-custom" (click)="cancel()"></div>
<div class="modal-dialog-custom card shadow-lg">
  <div class="card-header">
    <strong>{{ title }}</strong>
  </div>
  <div class="card-body">
    <p class="text-muted mb-3">
      <strong>Gasto:</strong> {{ expenseLabel }}
    </p>
    <textarea
      class="form-control"
      rows="4"
      [placeholder]="placeholder"
      [formControl]="messageControl"
    ></textarea>
    <div *ngIf="messageControl.touched && messageRequired && (messageControl.value?.length || 0) < 10"
         class="text-danger small mt-1">
      Mínimo 10 caracteres requeridos.
    </div>
  </div>
  <div class="card-footer d-flex justify-content-end gap-2">
    <button class="btn btn-outline-secondary" (click)="cancel()">Cancelar</button>
    <button class="btn" [ngClass]="confirmClass" (click)="confirm()">Confirmar</button>
  </div>
</div>
